import { FeedbackSubjectListItem } from '@shared/model/feedback';
import { IOption } from '@vtbhome/juicyfront/types';

export const selectedSubjectId = (
    fieldValue: IOption[] | undefined,
    subjects: FeedbackSubjectListItem[] | undefined
) => {
    if (!fieldValue || !fieldValue.length || !subjects || !subjects.length) {
        return;
    }
    return subjects.find((subject) => subject.code === fieldValue[0].value)?.id;
};
